import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { calculateOverallPercentage } from '../OwnersCenterForm/ownersCenterScheme';
import type { OwnersCenterFormType } from '../OwnersCenterForm/OwnersCenterForm.types';
import type { UseFormReturn } from 'react-hook-form';

export const usePercentageValidation = (formMethods: UseFormReturn<OwnersCenterFormType>) => {
  const { t } = useTranslation('enErrors');

  const validateTotalPercentage = useCallback(() => {
    const totalPercentage = calculateOverallPercentage(formMethods.getValues());
    if (totalPercentage > 100) {
      formMethods.setError('root.totalPercentage', {
        message: t('ownerCenter.ownershipPercentageTooHigh'),
      });
    } else {
      formMethods.clearErrors('root.totalPercentage');
    }
  }, [formMethods, t]);

  const validatePercentageChange = useCallback(
    async (fieldName: keyof OwnersCenterFormType): Promise<boolean> => {
      const isFieldValid = await formMethods.trigger(fieldName);
      if (!isFieldValid) return false;

      const totalPercentage = calculateOverallPercentage(formMethods.getValues());
      if (totalPercentage > 100) {
        formMethods.setError('root.totalPercentage', {
          message: t('ownerCenter.ownershipPercentageTooHigh'),
        });
        return false;
      }

      formMethods.clearErrors('root.totalPercentage');
      return true;
    },
    [formMethods, t]
  );

  return { validateTotalPercentage, validatePercentageChange };
};
